import { render, staticRenderFns } from "./AccordionPMList.vue?vue&type=template&id=24c4abdd"
import script from "./AccordionPMList.vue?vue&type=script&lang=js"
export * from "./AccordionPMList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports